import { Popup } from 'react-map-gl/mapbox';
import { formatDistanceToNow } from 'date-fns';
import { cn } from '@/lib/utils';

interface CanvasserPopupProps {
  volunteerName: string;
  volunteerInitials: string;
  isStale: boolean;
  lastUpdated: string; // ISO string
  lngLat: [number, number];
}

export function CanvasserPopup({
  volunteerName,
  volunteerInitials,
  isStale,
  lastUpdated,
  lngLat,
}: CanvasserPopupProps) {
  const timeAgo = formatDistanceToNow(new Date(lastUpdated), { addSuffix: true });

  return (
    <Popup
      longitude={lngLat[0]}
      latitude={lngLat[1]}
      anchor="bottom"
      closeOnClick={false}
      closeButton={false}
      maxWidth="220px"
      offset={16}
    >
      <div className="flex items-center gap-2 py-1">
        <div
          className={cn(
            'flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold text-white',
            isStale ? 'bg-gray-400' : 'bg-blue-500',
          )}
        >
          {volunteerInitials}
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-foreground">
            {volunteerName}
          </p>
          <p
            className={cn(
              'text-xs',
              isStale ? 'text-amber-600' : 'text-muted-foreground',
            )}
          >
            {isStale ? `Last seen ${timeAgo}` : `Active ${timeAgo}`}
          </p>
        </div>
      </div>
    </Popup>
  );
}
